export const DOCUMENTS_FORMATS_MAP: Record<string, string> = {
  'application/pdf': 'pdf',
  'text/csv': 'csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
};

export const DOCUMENTS_TYPE_MAP: Record<string, string> = {
  FACTSHEET: 'Factsheet',
  KIID: 'KIID',
  Prospectus: 'Prospectus',
};
